import { Button, Card, CardBody, Input, Textarea } from '@nextui-org/react';
import React from 'react';
import { useForm } from 'react-hook-form';
import { patchFetcher } from '../../../../services/api';
import toast from 'react-hot-toast';

export default function Form({ data, mutate, className }) {
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();

  async function onSubmitForm(formData) {
    try {
      formData.changedBy = 'admin-id'; // Replace with actual admin ID
      await patchFetcher(`/api/tickets/${data.id}/update-status`, formData);
      mutate();
      reset();
      toast.success('Ticket updated successfully!');
    } catch (error) {
      toast.error('Failed to update ticket.');
    }
  }

  return (
    <Card radius="sm" className={className}>
      <CardBody>
        {data?.status === 'Closed' ? (
          <div className="h-full flex flex-col items-center justify-center text-center">
            <span className="text-ink-400">No updates can be made to closed tickets.</span>
          </div>
        ) : (
          <form onSubmit={handleSubmit(onSubmitForm)}>
            <div className="flex flex-col gap-3 mb-6">
              <Input
                {...register('changedAt')}
                isRequired
                variant="faded"
                type="date"
                label="Change Date"
                color={errors.changedAt ? 'danger' : 'default'}
                isInvalid={!!errors.changedAt}
                errorMessage={errors.changedAt && errors.changedAt.message}
              />
              <Textarea
                {...register('notes')}
                isRequired
                variant="faded"
                label="Notes"
                color={errors.notes ? 'danger' : 'default'}
                isInvalid={!!errors.notes}
                errorMessage={errors.notes && errors.notes.message}
              />
              <Input
                {...register('newStatus')}
                isRequired
                variant="faded"
                label="New Status"
                placeholder="Enter new status"
                color={errors.newStatus ? 'danger' : 'default'}
                isInvalid={!!errors.newStatus}
                errorMessage={errors.newStatus && errors.newStatus.message}
              />
            </div>
            <Button isLoading={isSubmitting} isDisabled={isSubmitting} type="submit" color="primary">
              Submit
            </Button>
          </form>
        )}
      </CardBody>
    </Card>
  );
}
